import { useState } from 'react';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import GoogleCompanyStep from './GoogleCompanyStep';

const AuthContainer = ({ onLogin }) => {
  // The marketing site's "Start free" buttons carry ?signup=1. Without this a
  // first-time visitor who has just been told "no card needed, about five
  // minutes" lands on a password prompt for an account they do not have.
  const wantsSignup = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('signup') === '1';
  const [isLoginMode, setIsLoginMode] = useState(!wantsSignup);
  // Set when a brand-new Google user needs to provide a company name.
  const [pendingGoogle, setPendingGoogle] = useState(null);

  const handleSwitchToSignup = () => setIsLoginMode(false);
  const handleSwitchToLogin = () => setIsLoginMode(true);

  const handleSignup = (token, userInfo) => {
    // After successful signup, treat it the same as login
    onLogin(token, userInfo);
  };

  const handleNeedsCompany = (credential, google) => {
    setPendingGoogle({ credential, ...(google || {}) });
  };

  if (pendingGoogle) {
    return (
      <GoogleCompanyStep
        pending={pendingGoogle}
        onLogin={onLogin}
        onCancel={() => setPendingGoogle(null)}
      />
    );
  }

  return (
    <>
      {isLoginMode ? (
        <LoginPage
          onLogin={onLogin}
          onSwitchToSignup={handleSwitchToSignup}
          onNeedsCompany={handleNeedsCompany}
        />
      ) : (
        <SignupPage
          onSignup={handleSignup}
          onSwitchToLogin={handleSwitchToLogin}
          onNeedsCompany={handleNeedsCompany}
        />
      )}
    </>
  );
};

export default AuthContainer;
